"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactNumberFormat = _interopRequireDefault(require("react-number-format"));

var _Label = _interopRequireDefault(require("./Label"));

var _Flex = require("../../Layout/Flex");

var _InputContainer = _interopRequireDefault(require("../../Form/Input/InputContainer"));

var _Constant = require("../Constant");

var _Input = require("./Input");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  font-size: 1.8rem;\n  font-style: normal;\n  font-weight: bold;\n  line-height: 1.38;\n  color: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  flex-basis: 6.2rem;\n  flex-shrink: 0;\n  flex-grow: 0;\n  height: 6.2rem;\n  background: ", ";\n  border-right: 1px solid white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  align-items: flex-end;\n  border: 1px solid ", ";\n  margin-top: 9px;\n\n  input {\n    ", "\n    ", ";\n\n    &:disabled {\n      color: ", " !important;\n    }\n  }\n\n  /* disabledStyles is used instead of the disabled attribute because border styles are placed on the InputWrapper instead of directly on the input */\n  &:hover {\n    border-color: ", ";\n  }\n\n  /* The focus ring surrounds both the input and CurrencySignContainer when the input has focus */\n  &:focus-within {\n    outline: 2px solid ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

// NumberFormat automatically proxies unknown props as html attributes so will warn if passed errorText directly.
var InputWrapper = (0, _styledComponents.default)(_Flex.FlexContainer).attrs(function (_ref) {
  var errorText = _ref.errorText;
  return {
    'data-error': errorText && errorText.length > 0
  };
})(_templateObject(), function (props) {
  return props['data-error'] ? _Constant.Color.LIPSTICK_RED : _Constant.Color.GREY_4;
}, _Input.inputStyles, _Input.dashboardStyles, _Constant.Color.BLACK_SOUL, function (props) {
  return props.disabledStyles ? '' : _Constant.Color.FOCUS_B;
}, _Constant.Color.FOCUS_B);
var CurrencySignContainer = (0, _styledComponents.default)(_Flex.FlexItem)(_templateObject2(), _Constant.Color.GREY_2);

var CurrencySign = _styledComponents.default.div(_templateObject3(), _Constant.Color.GREY_7);

var CurrencyInput = function CurrencyInput(_ref2) {
  var id = _ref2.id,
      label = _ref2.label,
      decimalScale = _ref2.decimalScale,
      thousandSeparator = _ref2.thousandSeparator,
      decimalSeparator = _ref2.decimalSeparator,
      fixedDecimalScale = _ref2.fixedDecimalScale,
      allowNegative = _ref2.allowNegative,
      prefix = _ref2.prefix,
      warning = _ref2.warning,
      errorText = _ref2.errorText,
      value = _ref2.value,
      onChange = _ref2.onChange,
      className = _ref2.className,
      isHiddenLabel = _ref2.isHiddenLabel,
      disabled = _ref2.disabled,
      alignLabelLeft = _ref2.alignLabelLeft,
      fsMask = _ref2.fsMask,
      otherProps = (0, _objectWithoutProperties2.default)(_ref2, ["id", "label", "decimalScale", "thousandSeparator", "decimalSeparator", "fixedDecimalScale", "allowNegative", "prefix", "warning", "errorText", "value", "onChange", "className", "isHiddenLabel", "disabled", "alignLabelLeft", "fsMask"]);

  var inputProps = _objectSpread(_objectSpread({}, otherProps), {}, {
    type: 'tel',
    id: id,
    value: value,
    decimalScale: decimalScale,
    thousandSeparator: thousandSeparator,
    decimalSeparator: decimalSeparator,
    fixedDecimalScale: fixedDecimalScale,
    allowNegative: allowNegative,
    prefix: prefix,
    disabled: disabled,
    onValueChange: function onValueChange(_ref3) {
      var value = _ref3.value;
      var parseValue = decimalScale > 0 ? Number.parseFloat : function (val) {
        return Number.parseInt(val, 10);
      };
      var parsedValue = value;
      if (typeof value === 'string') parsedValue = value.length > 0 ? parseValue(value) : undefined;
      return onChange(parsedValue);
    },
    'aria-invalid': errorText ? 'true' : null
  });

  var disabledStyles = disabled ? true : false; // @todo apply new label styles

  return /*#__PURE__*/_react.default.createElement(_InputContainer.default, {
    className: className,
    alignLabelLeft: alignLabelLeft
  }, /*#__PURE__*/_react.default.createElement(_Label.default, {
    htmlFor: id,
    value: value,
    errorText: errorText,
    isVisuallyHidden: isHiddenLabel
  }, label), /*#__PURE__*/_react.default.createElement(InputWrapper, {
    errorText: errorText,
    warning: warning,
    disabledStyles: disabledStyles
  }, prefix !== '' && /*#__PURE__*/_react.default.createElement(CurrencySignContainer, null, /*#__PURE__*/_react.default.createElement(CurrencySign, null, prefix)), /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, (0, _extends2.default)({
    className: "".concat(fsMask ? 'fs-mask ' : '')
  }, inputProps))));
};

CurrencyInput.propTypes = {
  /** The id for the input */
  id: _propTypes.default.string.isRequired,

  /** The label for the input */
  label: _propTypes.default.string.isRequired,

  /** Value that controls the  */
  value: _propTypes.default.number,

  /** Show warning icon */
  warning: _propTypes.default.bool,

  /** Used for validation */
  errorText: _propTypes.default.string,

  /** If defined it limits to given decimal scale */
  decimalScale: _propTypes.default.number,

  /** Add thousand separators on number */
  thousandSeparator: _propTypes.default.bool,

  /** Support decimal point on a number */
  decimalSeparator: _propTypes.default.string,

  /** If true it add 0s to match given decimalScale */
  fixedDecimalScale: _propTypes.default.bool,

  /** Whether or not to allow a negative number */
  allowNegative: _propTypes.default.bool,

  /** Whether or not to allow a decimals */

  /** Prefix of the number */
  prefix: _propTypes.default.string,

  /** Function used to update the value prop */
  onChange: _propTypes.default.func.isRequired,

  /** allow overwriting styles */
  className: _propTypes.default.string,

  /** Ideally, label text is always visible.
   * If necessary, this prop will hide label text from sighted users while still making it available to assistive technology.
   * It will not hide error text.
   */
  isHiddenLabel: _propTypes.default.bool,

  /**
   * Adds `disabled` attribute to button when true.
   * Also used to prevent hover styles when input is disabled.
   */
  disabled: _propTypes.default.bool,

  /** Whether the label is display on the left of the input field */
  alignLabelLeft: _propTypes.default.bool,

  /** Toggles masking input within FullStory */
  fsMask: _propTypes.default.bool
};
CurrencyInput.defaultProps = {
  value: undefined,
  warning: false,
  errorText: '',
  decimalScale: 0,
  thousandSeparator: true,
  decimalSeparator: '.',
  fixedDecimalScale: true,
  allowNegative: false,
  prefix: '$',
  className: '',
  isHiddenLabel: false,
  disabled: false,
  alignLabelLeft: false,
  fsMask: true
};
var _default = CurrencyInput;
exports.default = _default;